import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6ecf018"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "F.A.Q", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "How can I delete my account including all my personal information?", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "From the main menu", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Use the profile button", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "to open up the profile screen.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "On the profile screen", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Use the companion history button", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "to open up the history screen.", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "On the history screen", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "you can see the complete conversation history between you and your companion.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Click on the exit button", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "to quit TB Companion.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "On the termination screen", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "you can choose the reason why you want to quit from one of the options.", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Click the confirmation button", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "to confirm the deletion of your account, including all your personal information.", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please be aware that this step cannot be undone.", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "If you would like to use the app again, you need to restart the app and register again.", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Use the cancel button", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "to cancel the termination process and return to the previous screen.", -1))
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "F.A.Q", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Cum îmi pot șterge contul, inclusiv toate informațiile mele personale?", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Din meniul principal", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Folosiți butonul de profil", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "pentru a deschide ecranul de profil.", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pe ecranul profilului", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Folosiți butonul istoric însoțitor", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "pentru a deschide ecranul istoric.", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pe ecranul istoric", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "poți vedea istoricul complet al conversațiilor dintre tine și însoțitorul tău.", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Faceți clic pe butonul de ieșire", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "pentru a părăsi TB Companion.", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pe ecranul de terminare", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "puteți alege motivul pentru care doriți să renunțați dintr-una dintre opțiuni.", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Faceți clic pe butonul de confirmare", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "pentru a confirma ștergerea contului dvs., inclusiv a tuturor informațiilor dvs. personale.", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Vă rugăm să rețineți că acest pas nu poate fi anulat.", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Dacă doriți să utilizați din nou aplicația, trebuie să reporniți aplicația și să vă înregistrați din nou.", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Folosiți butonul de anulare", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "pentru a anula procesul de terminare și a reveni la ecranul anterior.", -1))
const _hoisted_44 = { key: 2 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "F.A.Q", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Як я можу видалити свій обліковий запис разом із усією особистою інформацією?", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "З головного меню", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Використовуйте кнопку профілю", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "щоб відкрити екран профілю.", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "На екрані профілю", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Використовуйте кнопку історії компаньйонів", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "щоб відкрити екран історії.", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "На екрані історії", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ви можете переглянути повну історію розмов між вами та вашим супутником.", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Натисніть на кнопку виходу", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "щоб вийти з TB Companion.", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "На екрані завершення", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ви можете вибрати причину, чому ви хочете вийти з одного з варіантів.", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Натисніть кнопку підтвердження", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "щоб підтвердити видалення вашого облікового запису, включаючи всю вашу особисту інформацію.", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Майте на увазі, що цей крок не можна скасувати.", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Якщо ви хочете використовувати програму знову, вам потрібно перезапустити програму та зареєструватися знову.", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Скористайтеся кнопкою скасування", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "щоб скасувати процес завершення та повернутися до попереднього екрана.", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bannerimage",
  src: "/banner.png",
  alt: "banner"
}, null, -1))

export function render(_ctx, _cache) {
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_Language = _resolveComponent("Language")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigation),
    _createVNode(_component_Language),
    (_ctx.lang=='en')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.windowWidth >= 892 ? 'content-screen' : 'content')
          }, [
            _hoisted_3,
            _hoisted_4,
            _createVNode(_component_el_row, {
              class: "support",
              gutter: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: "/screen_support1.webp" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xl: 11,
                  lg: 11,
                  md: 11,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _hoisted_6,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_profile.webp"
                    }),
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              class: "support",
              gutter: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: "/screen_support2.webp" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xl: 11,
                  lg: 11,
                  md: 11,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _hoisted_9,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_history.webp"
                    }),
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              class: "support",
              gutter: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: "/screen_support3.webp" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xl: 11,
                  lg: 11,
                  md: 11,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_quit.webp"
                    }),
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              class: "support",
              gutter: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: "/screen_support4.webp" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xl: 11,
                  lg: 11,
                  md: 11,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_confirm.webp"
                    }),
                    _hoisted_18,
                    _hoisted_19,
                    _hoisted_20,
                    _hoisted_21,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_cancel.webp"
                    }),
                    _hoisted_22
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.lang=='ro')
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.windowWidth >= 892 ? 'content-screen' : 'content')
          }, [
            _hoisted_24,
            _hoisted_25,
            _createVNode(_component_el_row, {
              class: "support",
              gutter: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: "/screen_support1.webp" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xl: 11,
                  lg: 11,
                  md: 11,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_26,
                    _hoisted_27,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_profile.webp"
                    }),
                    _hoisted_28
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              class: "support",
              gutter: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: "/screen_support2.webp" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xl: 11,
                  lg: 11,
                  md: 11,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_29,
                    _hoisted_30,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_history.webp"
                    }),
                    _hoisted_31
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              class: "support",
              gutter: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: "/screen_support3.webp" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xl: 11,
                  lg: 11,
                  md: 11,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_32,
                    _hoisted_33,
                    _hoisted_34,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_quit.webp"
                    }),
                    _hoisted_35
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              class: "support",
              gutter: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: "/screen_support4.webp" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xl: 11,
                  lg: 11,
                  md: 11,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_36,
                    _hoisted_37,
                    _hoisted_38,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_confirm.webp"
                    }),
                    _hoisted_39,
                    _hoisted_40,
                    _hoisted_41,
                    _hoisted_42,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_cancel.webp"
                    }),
                    _hoisted_43
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.lang=='uk')
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.windowWidth >= 892 ? 'content-screen' : 'content')
          }, [
            _hoisted_45,
            _hoisted_46,
            _createVNode(_component_el_row, {
              class: "support",
              gutter: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: "/screen_support1.webp" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xl: 11,
                  lg: 11,
                  md: 11,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_47,
                    _hoisted_48,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_profile.webp"
                    }),
                    _hoisted_49
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              class: "support",
              gutter: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: "/screen_support2.webp" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xl: 11,
                  lg: 11,
                  md: 11,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_50,
                    _hoisted_51,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_history.webp"
                    }),
                    _hoisted_52
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              class: "support",
              gutter: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: "/screen_support3.webp" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xl: 11,
                  lg: 11,
                  md: 11,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_53,
                    _hoisted_54,
                    _hoisted_55,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_quit.webp"
                    }),
                    _hoisted_56
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              class: "support",
              gutter: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, { src: "/screen_support4.webp" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xl: 11,
                  lg: 11,
                  md: 11,
                  sm: 12,
                  class: "col-screen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_57,
                    _hoisted_58,
                    _hoisted_59,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_confirm.webp"
                    }),
                    _hoisted_60,
                    _hoisted_61,
                    _hoisted_62,
                    _hoisted_63,
                    _createVNode(_component_el_image, {
                      class: "image-button",
                      src: "/screen_support_button_cancel.webp"
                    }),
                    _hoisted_64
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _hoisted_65
  ]))
}